import * as React from "react";
import clsx from "clsx";
import { Link, OrgAvatar } from "@talentpair/quantic";
import { PublicJobT } from "@talentpair/types/public";

interface JobHeaderProps {
  job: PublicJobT;
  isLink?: boolean;
  orgLink?: null | string;
  pathname?: string;
}

export default function JobHeader({
  job,
  isLink,
  orgLink,
  pathname,
}: JobHeaderProps): React.ReactElement {
  return (
    <div className="flex items-center">
      <OrgAvatar org={job.organization} background="primary.main" />
      <div className="flex flex-column ml2">
        {isLink ? (
          <Link target="_self" className="black" href={pathname}>
            <div className={clsx("h3", "hover-underline")}>{job.role?.name || "Unknown Role"}</div>
          </Link>
        ) : (
          <div className={clsx("h3")}>{job.role?.name || "Unknown Role"}</div>
        )}
        {job.organization ? (
          orgLink ? (
            <Link target="_self" href={orgLink} color="primary">
              <div className="bold h5">{job.organization?.name}</div>
            </Link>
          ) : (
            <div className="bold h5">{job.organization?.name}</div>
          )
        ) : null}
      </div>
    </div>
  );
}
